import competetiveAdvantageIcon from '../../../public/svg/icons/whyUseZKP/CompetitiveAdvantage.svg';
import enhancedPrivacySecurityIcon from '../../../public/svg/icons/whyUseZKP/EnhancedPrivacyAndSecurity.svg';
import massiveScalabilityGainsIcon from '../../../public/svg/icons/whyUseZKP/MassiveScalabilityGains.svg';
import regulatoryComplianceIcon from '../../../public/svg/icons/whyUseZKP/RegulatoryCompliance.svg';

export const whyUseZKPData = {
  mainText: `Why Use ZKP in Your Project?`,
  description: ``,
  services: [
    {
      title: 'Enhanced Privacy & Security',
      description:
        'Verify transactions and computations without exposing sensitive data. Users can prove eligibility, ownership, or compliance without revealing personal information.',
      img: enhancedPrivacySecurityIcon,
      list: [
        'Private financial transactions',
        'Confidential identity verification',
        'Protected business logic',
        'Secure multi-party computations',
      ],
    },
    {
      title: 'Massive Scalability Gains',
      description:
        'Process thousands of transactions off-chain while maintaining blockchain security. ZK rollups can achieve 100x-1000x throughput improvements.',
      img: massiveScalabilityGainsIcon,
      list: [
        'Sub-second transaction finality',
        'Dramatically reduced gas costs',
        'Higher transaction throughput',
        'Maintained security guarantees',
      ],
    },
    {
      title: 'Regulatory Compliance',
      description:
        'Meet privacy regulations like GDPR while maintaining auditability. Prove compliance without exposing sensitive business or personal data.',
      img: regulatoryComplianceIcon,
      list: [
        'GDPR-compliant data handling',
        'Auditable without data exposure',
        'Selective disclosure capabilities',
        'Future-proof privacy architecture',
      ],
    },
    {
      title: 'Competitive Advantage',
      description:
        "Build trust with users who value privacy. Enable new business models that weren't possible with traditional transparent blockchains.",
      img: competetiveAdvantageIcon,
      list: [
        'Differentiate from competitors',
        'Enable sensitive use cases',
        'Build user trust & adoption',
        'Future-ready architecture',
      ],
    },
  ],
};
